import React from "react";
import { Slider, Handles, Tracks, Rail } from "react-compound-slider";
import { Handle, Track, SliderRail } from "./components"; // example render components - source below

const sliderStyle = {
  position: "relative",
  width: "100%"
};

const RangeSliderCompound = ({ value, min, max, onChange }) => {
  return (
    <div style={{ margin: "10%", height: 40, width: 99 }}>
      <Slider
        mode={1}
        step={1}
        domain={[min, max]}
        rootStyle={sliderStyle}
        onSlideEnd={onChange}
        values={value}
      >
        <Rail>
          {({ getRailProps }) => <SliderRail getRailProps={getRailProps} />}
        </Rail>
        <Handles>
          {({ handles, getHandleProps }) => (
            <div className="slider-handles">
              {handles.map(handle => (
                <Handle
                  key={handle.id}
                  handle={handle}
                  domain={[min, max]}
                  getHandleProps={getHandleProps}
                />
              ))}
            </div>
          )}
        </Handles>
        <Tracks left={false} right={false}>
          {({ tracks, getTrackProps }) => (
            <div className="slider-tracks">
              {tracks.map(({ id, source, target }) => (
                <Track
                  key={id}
                  source={source}
                  target={target}
                  getTrackProps={getTrackProps}
                />
              ))}
            </div>
          )}
        </Tracks>
      </Slider>
    </div>
  );
};

export default RangeSliderCompound;
